import { cloneFinderData } from "#ce/components/SpFinder/engine/finder-data";

export function createRequestLifecycle({ api, onRequest, onComplete, onError, required = () => true }) {
  let generation = 0;
  let disposed = false;
  let controller;

  function cancel() {
    generation += 1;
    controller?.abort();
    controller = undefined;
  }

  async function request(url, params, presentation) {
    if (disposed) {
      return;
    }
    cancel();
    if (!required(params)) {
      return;
    }

    const currentGeneration = generation;
    controller = new AbortController();
    const current = { generation: currentGeneration, params: cloneFinderData(params), url };
    if (presentation) {
      current.presentation = cloneFinderData(presentation);
    }
    onRequest?.(current);

    try {
      const result = await api.fetch(url, { signal: controller.signal });
      if (!disposed && generation === currentGeneration) {
        onComplete?.({ ...current, ...result });
      }
    } catch (error) {
      if (!disposed && generation === currentGeneration && error.name !== "AbortError") {
        onError?.({ ...current, error });
      }
    }
  }

  function dispose() {
    disposed = true;
    cancel();
  }

  return Object.freeze({ request, cancel, dispose });
}
